import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import { RateCardContainerModel } from "../../../../../models/aggregates/pgw/ratecard.model";
import { RateCardCriteriaModelQuery, RateCardQueryCriteriaClass } from "../../criteria/pgw/ratecard-criteria.model";

@Injectable({
  providedIn: "root",
})
export class RateCardService extends BaseApiTemplateService<RateCardContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-cards";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-cards";
    this.httpClient = http;
  }

  getRateCardByCriteria(
    visa: ApiVisa,
    criteria?: RateCardQueryCriteriaClass
  ): Observable<PagingResponseModel<RateCardContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildRateCardCriteria = new RateCardCriteriaModelQuery(criteria);
    console.log("query", buildRateCardCriteria.query);
    return this.httpClient.get<PagingResponseModel<RateCardContainerModel>>(
      this.apiUrl + "/query?" + buildRateCardCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
